module.exports = __webpack_public_path__ + "static/media/customize-icon.06e4160f.svg";